/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import QtmColor from './Color';
import common from './common';

const orange: QtmColor = {
  50: '#fff3e0',
  100: '#fee0b3',
  200: '#fecc81',
  300: '#fdb74f' /* light */,
  400: '#fda72a',
  500: '#fd980a',
  600: '#f98c09',
  700: '#f27d07' /* primary */,
  800: '#ec6d06',
  900: '#e35305' /* dark */,
  contrast: {
    50: common.black,
    100: common.black,
    200: common.black,
    300: common.black,
    400: common.black,
    500: common.black,
    600: common.black,
    700: common.black,
    800: common.black,
    900: common.black,
  },
};

export default orange;
